import { Action, ActionDefinition } from "components/actions/actions";
import { Component, ComponentDefinition, DataHolderComponent, NeedsUnhideComponent } from "components/components/Component";
import { DocumentBind } from "components/events/documentBind";
import { FieldRestriction } from "components/restrictions/FieldRestriction";
import { RestrictionAttribute } from "components/restrictions/Restrictions";
import template from "components/actionButton/actionButton.hbs";
import "./actionButton.scss";
import { ActionButtonElement } from "components/actionButton/actionButtonElement";

export class ActionButton implements Component, NeedsUnhideComponent {

    public readonly componentType: string = "actionButton";
    public readonly id: string;
    public readonly definition: Definition;
    public view: ActionButtonElement;
    private dataHolder: DataHolderComponent;
    private enabled: boolean;

    private listener = (e: CustomEvent) => {
        if (
            this.definition.action != null
            && e.detail.phase === "begin"
            && e.detail.action != null
            && e.detail.action.definition.actionName === this.definition.action.actionName) {
            this.setLoading();
        } else if (
            this.definition.action != null
            && e.detail.phase === "finish"
            && e.detail.action != null
            && e.detail.action.definition.actionName === this.definition.action.actionName) {
            this.unsetLoading();
        }
    }

    constructor(definition: ActionButtonDefinition) {
        this.definition = Object.assign({ actionName: definition.action?.actionName }, definition);
        this.id = this.definition.id;
        if (this.definition.iconFont != null) {
            this.definition.iconClass = "hasIcon";
        } else {
            this.definition.iconClass = "hasNoIcon";
        }
        if (this.definition.style == null) {
            this.definition.style = "default";
        }
    }

    public render(): Element {
        const d = document.createElement("div");
        d.innerHTML = template(this.definition);
        this.view = d.firstChild as ActionButtonElement;
        this.view.clickListener = this.clickListener;
        this.enable();
        return this.view;
    }

    public postRender(): Node {
        DocumentBind.bindEvent(this.id, "sislogActionEvent", this.listener);
        return this.view;
    }
    public unhide(): void {
        DocumentBind.bindEvent(this.id, "sislogActionEvent", this.listener);
    }

    public hide() {
        (this.view as HTMLElement).style.display = "none";
    }

    public show() {
        (this.view as HTMLElement).style.display = "inline-block";

    }
    private clickListener = () => {
        let data: any;
        if (this.definition.action == null) {
            return;
        }
        if (this.dataHolder != null) {
            data = this.dataHolder.selectDataForAction(this.definition.action);
            new Action(this.definition.action, this).run(data, this.dataHolder);
        } else {
            new Action(this.definition.action, this).run(null);
        }
    }

    public disable = () => {
        this.enabled = false;
        this.view.disable();
    }

    public enable = () => {
        this.enabled = true;
        this.view.enable();
    }

    public isEnabled() {
        return this.enabled;
    }

    public applyRestrictions(restricions: FieldRestriction) {
        if (restricions?.attributes?.includes(RestrictionAttribute.hidden)) {
            this.hide();
        } else {
            this.show();
        }
        if (restricions?.attributes?.includes(RestrictionAttribute.readonly)) {
            this.disable();
        } else {
            this.enable();
        }
    }

    public bindDataHolder(component: DataHolderComponent) {
        this.dataHolder = component;
    }

    public setLoading() {
        this.view.disable();
        this.view.getElementsByTagName("i").item(0).classList.remove(this.definition.iconFont);
        this.view.getElementsByTagName("i").item(0).classList.add("fa-circle-o-notch");
        this.view.getElementsByTagName("i").item(0).classList.add("fa-spin");
    }

    public unsetLoading() {
        if (this.enabled) {
            this.enable();
        }
        this.view.getElementsByTagName("i").item(0).classList.add(this.definition.iconFont);
        this.view.getElementsByTagName("i").item(0).classList.remove("fa-circle-o-notch");
        this.view.getElementsByTagName("i").item(0).classList.remove("fa-spin");
    }
}

export interface ActionButtonDefinition extends ComponentDefinition {
    style: string;
    labelKey: string;
    iconFont?: string;
    action: ActionDefinition;
}

export interface Definition extends ActionButtonDefinition {
    iconClass?: string;
}

export function isActionButton(arg: any): arg is ActionButton {
    return arg.componentType === "actionButton";
}
